import axios from "axios";
import { baseURL } from "../globals/constants";
import { NavigateFunction } from "react-router-dom";
import { showErrorToast } from "../utils/Toast";
import i18next from "i18next";

export const getTenant = async (
    id: string,
    isMobile: boolean,
    navigate: NavigateFunction
) => {
    const token = localStorage.getItem("access_token");
    try {
        const response  = await axios.get(
            `${baseURL}/v1/users/${id}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            },
        );
        return response.data;
    } catch (error: any) {
        if (error.response.status == 401) {
            showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
            localStorage.removeItem("access_token")
            navigate("/")
        }
        console.log("error ", error)
    }
};
// Extra insight the tenant turned on itself (teams of 2-4 / per person) - see backend modules/privacy/insightAccess.service.ts
export type InsightLevel = "smallGroups" | "persons";
export interface InsightLevelState {
    enabled?: boolean;
    informedAt?: string | null;
    effectiveAt?: string | null;
    waivedNotice?: boolean;
    acceptedAt?: string | null;
    acceptedBy?: string | null;
    version?: number | null;
    disabledAt?: string | null;
    disabledBy?: string | null;
    disabledByRole?: "tenant" | "admin" | null;
}

const authHeaders = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });

/** The tenant's levels, from the user record (empty when nothing was ever turned on) */
export const getTenantInsightAccess = async (tenantId: string): Promise<Partial<Record<InsightLevel, InsightLevelState>>> => {
    const response = await axios.get(`${baseURL}/v1/users/${tenantId}`, authHeaders());
    return response.data?.insightAccess || {};
};

/** Superadmin turns a level off. The API answers 428 without a reason; the support-mode dialog asks for one and retries. */
export const disableTenantInsight = async (tenantId: string, level: InsightLevel) =>
    (await axios.patch(`${baseURL}/v1/users/admin/tenant/${tenantId}/insight-access`, { level, enabled: false }, authHeaders())).data;
